import React from 'react';
import { CellRenderProps } from '../types';

interface CellBaseProps extends CellRenderProps {
	children: React.ReactNode;
	onKeyPress?: (
		event: React.KeyboardEvent<HTMLDivElement>,
		props: CellRenderProps
	) => void;
	onKeyDown?: (
		event: React.KeyboardEvent<HTMLDivElement>,
		props: CellRenderProps
	) => void;
	onKeyUp?: (
		event: React.KeyboardEvent<HTMLDivElement>,
		props: CellRenderProps
	) => void;
	onFocus?: (
		event: React.FocusEvent<HTMLDivElement, Element>,
		props: CellRenderProps
	) => void;
	onBlur?: (
		event: React.FocusEvent<HTMLDivElement, Element>,
		props: CellRenderProps
	) => void;
	onClick?: (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
		props: CellRenderProps
	) => void;
	onDoubleClick?: (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
		props: CellRenderProps
	) => void;
	onMouseOver?: (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
		props: CellRenderProps
	) => void;
	onMouseOut?: (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
		props: CellRenderProps
	) => void;
}

export const CellBase = (props: CellBaseProps) => {
	const {
		onKeyPress,
		onKeyDown,
		onKeyUp,
		onFocus,
		onBlur,
		onClick,
		onDoubleClick,
		onMouseOver,
		onMouseOut,
	} = props;
	return (
		<div
			tabIndex={0}
			style={props.style}
			onKeyPress={(event) =>
				onKeyPress
					? onKeyPress(event, props)
					: props.api.onKeyPress(event, props)
			}
			onKeyDown={(event) =>
				onKeyDown
					? onKeyDown(event, props)
					: props.api.onKeyDown(event, props)
			}
			onKeyUp={(event) =>
				onKeyUp
					? onKeyUp(event, props)
					: props.api.onKeyUp(event, props)
			}
			onFocus={(event) =>
				onFocus
					? onFocus(event, props)
					: props.api.onFocus(event, props)
			}
			onBlur={(event) =>
				onBlur ? onBlur(event, props) : props.api.onBlur(event, props)
			}
			onClick={(event) =>
				onClick
					? onClick(event, props)
					: props.api.onClick(event, props)
			}
			onDoubleClick={(event) =>
				onDoubleClick
					? onDoubleClick(event, props)
					: props.api.onDoubleClick(event, props)
			}
			onMouseOver={(event) =>
				onMouseOver
					? onMouseOver(event, props)
					: props.api.onMouseOver(event, props)
			}
			onMouseOut={(event) =>
				onMouseOut
					? onMouseOut(event, props)
					: props.api.onMouseOut(event, props)
			}
		>
			{props.children}
		</div>
	);
};
